import { createReducer, on } from '@ngrx/store';
import * as ProductActions from './product.actions';
import { Product } from './product.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface ProductsState {
    products: Product[];
    product: Product | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialProductsState: ProductsState = {
    products: [],
    product: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Products Reducer
export const productsReducer = createReducer(
    initialProductsState,

    // On Load Products
    on(ProductActions.loadProducts, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ProductActions.loadProductsSuccess, (state, { products }) => ({
        ...state,
        isLoading: false,
        products: products,
    })),
    on(ProductActions.loadProductFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Products By Category
    on(ProductActions.loadProductsByCategory, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ProductActions.loadProductsByCategorySuccess, (state, { products }) => ({
        ...state,
        isLoading: false,
        products: products,
    })),
    on(ProductActions.loadProductsByCategoryFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Products By Category Name
    on(ProductActions.loadProductsByCategoryName, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ProductActions.loadProductsByCategoryNameSuccess,
        (state, { products }) => ({
            ...state,
            isLoading: false,
            products: products,
        })
    ),
    on(
        ProductActions.loadProductsByCategoryNameFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error: error,
        })
    ),

    // On Load Products By Subcategory
    on(ProductActions.loadProductsBySubcategory, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ProductActions.loadProductsBySubcategorySuccess,
        (state, { products }) => ({
            ...state,
            isLoading: false,
            products: products,
        })
    ),
    on(ProductActions.loadProductsBySubcategoryFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Products By Subcategory Name
    on(ProductActions.loadProductsBySubcategoryName, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ProductActions.loadProductsBySubcategoryNameSuccess,
        (state, { products }) => ({
            ...state,
            isLoading: false,
            products: products,
        })
    ),
    on(
        ProductActions.loadProductsBySubcategoryNameFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error: error,
        })
    ),

    // On Load Single Product
    on(ProductActions.loadProduct, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ProductActions.loadProductSuccess, (state, { product }) => ({
        ...state,
        isLoading: false,
        product: product,
    })),
    on(ProductActions.loadProductFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
